// generated by the plop

import { BackupsStateModel } from './backups.model';

export class ChangeBackupStatus {
  static type = '[backups] ChangeBackupStatus';

  constructor(public status: BackupsStateModel['status']) {
  }
}

export class GetBackupStatus {
  static type = '[backups] GetBackupStatus';
}

export class CreateBackup {
  static type = '[backups] CreateBackup';
}
